import { createSlice } from '@reduxjs/toolkit';

const routesAuth = createSlice({
  name: 'routesAuthSlice',
  initialState: {
    authorized: false,
  },
  reducers: {
    setAuthorized(state, action) {
      state.authorized = action.payload;
    },
  },
});

export const { setAuthorized } = routesAuth.actions;
export default routesAuth.reducer;
